import React, { useState } from "react";
import "./Login.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const res = await axios.post("https://hotfix-back-hris.talentfort.live/login", {
        username,
        password,
        role,
      });
      if (res.data.Login) {
        Cookies.set("username", res.data.username);
        Cookies.set("role", res.data.role);
        Cookies.set("token", res.data.accessToken); // ✅ store access token
        Cookies.set("refreshToken", res.data.refreshToken); // ✅ store refresh token (optional)
        Cookies.set("id", res.data.id);

        if (
          res.data.role === "Admin" ||
          res.data.role === "Super Admin" ||
          res.data.role === "Finance Admin" 
        ) {
          navigate("/dash");
        } else {
          navigate("/");
        }
      } else {
        setLoginError("Incorrect username or password. Please try again.");
      }
    } catch (error) {
      console.error(error);
      setLoginError("An error occurred during login. Please try again.");
    }
  };
  return (
    <div className="main_body">
      <div className="container">
        <h1 className="title">Human Resourse Information System</h1>
        <div className="login-form">
          <h2>Login</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="username">Username:</label>
              <input
                type="text"
                id="username"
                name="username"
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password:</label>
              <input
                type="password"
                id="password"
                name="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="role">Role :</label>
              <select
                type="text"
                className="form-control"
                id="role"
                name="role"
                value={role}
                onChange={(e) => setRole(e.target.value)}
                required
              >
                <option value=""></option>
                <option value="Admin">Admin</option>
                <option value="Super Admin">SuperAdmin</option>
                <option value="Finance Admin">Finance Admin</option>
              </select>
            </div>
            <button type="submit" className="btn btn-primary">
              Login
            </button>
            {loginError && <p className="error-message">{loginError}</p>}
          </form>
        </div>
      </div>
    </div>
  );
}
